import React, { Component } from 'react'
import { FormattedDate, FormattedMessage, FormattedNumber } from 'react-intl'
import { AppContext } from "@lightspeed-invoicing/core-client/frontend";
import BillingMethodTotalLabel from "../../../common/pricing/billingmethodtotallabel.component.jsx"
import NumericLabel from 'react-pretty-numbers'
import Icon from "../../../common/icon/icon.component.jsx";
import PricingTableModal from "../pricingtablemodal.component.jsx";
import OrderStatusBadge from "../../../order/status.component.jsx";
import InlineEditDate from "../../../common/inline-edit/date.component.jsx";
import ConfirmButton from "../../../common/button/confirmbutton.component.jsx";

class OrderStatusChangedEvent extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            object: this.props.object || null,
            proposal: this.props.proposal || null,
            order: this.props.order || null,
            onUpdate: this.props.onUpdate || function () { },
            modal: '',
            status: null,
        }
        this.deleteDate = this.deleteDate.bind(this)
    }

    componentDidMount() {
        const customStatusId = this.state.object.attributes.customStatusId
        const status = AppContext.getOrderStatusById(customStatusId)
        if (!status) {
            AppContext.getApiClient().get('/order-statuses/' + customStatusId).then(customStatus => {
                this.setState({
                    status: customStatus,
                })
            })
        } else {
            this.setState({
                status,
            })
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            object: nextProps.object || null,
            order: nextProps.order || null,
            proposal: nextProps.proposal || null,
        })
    }

    deleteDate(e) {
        e.preventDefault()
        AppContext.getApiClient().delete('/orders/' + this.state.order.id + '/custom-status-dates/' + this.state.object.id).then(res => {
            this.state.onUpdate()
        })
    }

    render() {
        return <div className={"row " + this.state.className}>
            {this.state.modal}
            <div className="col-12 d-flex justify-content-between">
                <div className={""}>
                    <FormattedMessage
                        id="order.analytics.events.order_changed_status_text"
                        defaultMessage="Order {identifier} status changed for {status} on {date}"
                        values={{
                            identifier: <strong>{this.state.order.attributes.identifier}</strong>,
                            status: <OrderStatusBadge
                                statusId={this.state.object.attributes.customStatusId}
                                status={this.state.status} />,
                            date: <InlineEditDate
                                value={this.state.object.attributes.changedAt}
                                endPoint={'/orders/' + this.state.order.id + '/custom-status-dates/' + this.state.object.id}
                                field={'changedAt'}
                                editable={true}
                            />,
                        }}
                    />
                </div>
                {this.state.status && this.state.status.attributes.type !== 'draft' && <div className={""}>
                    <ConfirmButton identifier={<OrderStatusBadge statusId={this.state.object.attributes.customStatusId} />} className={'btn btn-sm btn-outline-danger'} onClick={this.deleteDate}>
                        <Icon value={'trash'} className={'mr-1'} />
                        <FormattedMessage
                            id="order.analytics.events.order_changed_status.delete_btn"
                            defaultMessage="Delete"
                        />
                    </ConfirmButton>
                </div>}
            </div>
        </div>
    }

}

export default OrderStatusChangedEvent





// WEBPACK FOOTER //
// ./src/quote/analytics/events/order-status-changed.component.jsx